import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from "axios";

import request from "common/request";

type PaypleRegistrationMutationVariable = {
    termsCondition:boolean;
    personalInformation:boolean
    marketingConstent?: boolean,
};

export const usePostPayple = ( 
  options?: UseMutationOptions<any, AxiosError,PaypleRegistrationMutationVariable>
) => { 
  return useMutation<any, AxiosError, PaypleRegistrationMutationVariable>(
    async ({termsCondition, personalInformation, marketingConstent}) => {
      try {
        const response = await request.post('/product/detail',{
          termsCondition,
          personalInformation,
          marketingConstent
        });
        
        return response
      } catch(e){
        //@ts-ignore
        const result = e.response;
        return result
      }
    },
    {
      ...options
    }
  )
};

export default usePostPayple;